export default __webpack_public_path__ + "static/media/gallery_00.467ec289.jpg";